import { defineComponent as _defineComponent } from 'vue'
import { computed } from 'vue';
import { useFilterStore } from '@/stores/pinia/useFilterStore';
import ProviderIcon from '@/components/picture/ProviderIcon.vue';
import { useUserStore } from '@/stores/pinia/useUserStore';
import { useExperiment } from '@/libraries/experiment';


export default /*#__PURE__*/_defineComponent({
  __name: 'MyServicesChip',
  props: {
    buyboxType: null
  },
  setup(__props: any) {

const props = __props as {
	buyboxType: 'grid' | 'list';
};

const filterStore = useFilterStore();
const userStore = useUserStore();

const { trackEvent } = useExperiment('EXP_PROVIDER_BUYBOX');



const providersToDisplay = computed(() => filterStore.selectedProvidersByType('my_services').slice(0, 3));

const _buyboxType = computed(() => {
	if (props.buyboxType === 'grid') return 0;
	if (props.buyboxType === 'list') return 1;
	return 0;
});

const onVisibleCallback = {
	callback: (isVisible: boolean) => {
		if (isVisible) {
			trackEvent({
				action: 'impression',
				value: _buyboxType.value,
			});
		}
	},
};

return { __sfc: true,filterStore, userStore, trackEvent, props, providersToDisplay, _buyboxType, onVisibleCallback, ProviderIcon }
}

})